import React from 'react';
// import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
// import ribbon from '../../static/img/ribbon.png';

const chart = css({
  backgroundColor: '#fff',
  border: '1px solid #e6e6e6',
  borderRadius: '5px!important',
  boxShadow: '0 0 2px 0 rgba(181,181,181,.3)',
  padding: '20px 40px',
  textAlign: 'center',
  width: '280px',
  float: 'left',
  minHeight: 315,
  position: 'relative',
  top: 20,
});

const freePlan = css({
  backgroundColor: '#fff',
  border: '1px solid #e6e6e6',
  borderRadius: 5,
  boxShadow: '',
  padding: '20px 30px 10px 30px',
  textAlign: 'center',
  width: 220,
  position: 'absolute',
  right: 0,
  top: 20,
});

const Ribbon = styled('div')`
  width: 120px;
  height: 120px;
  position: absolute;
  overflow: hidden;
  top: -10px;
  left: -10px;
  z-index: 3;

  &::before,
  ::after {
    position: absolute;
    content: '';
    display: block;
    border: 5px solid #2980b9;
    border-top-color: transparent;
    border-left-color: transparent;
    z-index: -1;
  }
  &::before {
    top: 0;
    right: 22px;
  }

  &::after {
    bottom: 22px;
    left: 0;
  }
`;

const ribbonText = css({
  position: 'absolute',
  display: 'block',
  width: 230,
  padding: '8px 0',
  backgroundColor: '#3498db',
  color: '#fff',
  fontWeight: 700,
  fontSize: 8,
  textShadow: '0 1px 1px rgba(0,0,0,.2)',
  textTransform: 'uppercase',
  textAlign: 'center',
  right: -30,
  top: 30,
  transform: 'rotate(-45deg)',
});

// const mostPopular = css({
//   position: 'absolute',
//   top: 0,
//   left: 0,
// });

const planName = css({
  textAlign: 'center',
  fontSize: 20,
  fontWeight: 400,
  color: '#444',
  width: '90%',
  margin: '0 auto',
  marginTop: '5px',
});

const planCostWrapper = css({
  textAlign: 'center',
  borderBottom: '1px solid #d5d5d5',
  marginTop: 10,
});

const planCostDollar = css({
  fontSize: 19,
  position: 'relative',
  top: -18,
});

const planCostAmount = css({
  fontSize: 49,
});

const planCostFrequency = css({
  fontSize: 17,
  position: 'relative',
  top: -8,
  marginLeft: 4,
});

const planDetailWrapper = css({
  marginTop: 20,
});

const planDetail = css({
  fontSize: 15,
  color: '#353535',
  textAlign: 'center',
  fontWeight: 300,
  marginBottom: 13,
});

const planDetailHighlight = css({
  color: '#1fbee7',
  fontWeight: 400,
});

class PricingTable extends React.Component {
  render() {
    return (
      <div style={{ marginTop: 80 }}>
        <div className="row">
          <div className="col">
            <div className={chart} style={{}}>
              <div className={planName}>Bite size</div>
              <div className={planCostWrapper}>
                <span className={planCostDollar}>$</span>
                <span className={planCostAmount}>15</span>
                <span className={planCostFrequency}>/month</span>
              </div>
              <div className={planDetailWrapper}>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>5</span> Team Members
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>1</span> Project
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>3</span> Elements
                </div>
              </div>
            </div>

            <div
              className={chart}
              style={{
                margin: '0 auto',
                top: 0,
                minHeight: 445,
                zIndex: 2,
                left: -25,
              }}
            >
              <Ribbon>
                <span className={ribbonText}>Most Popular</span>
              </Ribbon>
              {/* <img alt="ribbon" className={mostPopular} src={ribbon} /> */}
              <div className={planName}>Smedium</div>
              <div className={planCostWrapper}>
                <span className={planCostDollar}>$</span>
                <span className={planCostAmount}>5,000</span>
                <span className={planCostFrequency}>/month</span>
              </div>
              <div className={planDetailWrapper}>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>5</span> Team Members
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>1</span> Project
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>3</span> Elements
                </div>
              </div>
            </div>

            <div className={chart} style={{ left: -45 }}>
              <div className={planName}>Big Boy Plan</div>
              <div className={planCostWrapper}>
                <span className={planCostDollar}>$</span>
                <span className={planCostAmount}>10,000</span>
                <span className={planCostFrequency}>/month</span>
              </div>
              <div className={planDetailWrapper}>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>5</span> Team Members
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>1</span> Project
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>3</span> Elements
                </div>
              </div>
            </div>

            <div className={freePlan}>
              <div className={planName}>Free</div>
              <div className={planCostWrapper}>
                <span className={planCostDollar}>$</span>
                <span className={planCostAmount}>0</span>
                <span className={planCostFrequency}>/month</span>
              </div>
              <div className={planDetailWrapper}>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>5</span> Team Members
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>1</span> Project
                </div>
                <div className={planDetail}>
                  <span className={planDetailHighlight}>3</span> Elements
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PricingTable;



// WEBPACK FOOTER //
// ./src/views/public/Pricing/PricingTable.js